import { CloseOutlined } from "@ant-design/icons";
import { Col, Collapse, Flex, Form, message, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import {
  CustomButton,
  CustomDynamicSelect,
  CustomInput,
  CustomParagraph,
  CustomSelect,
  CustomTitle,
} from "../../components";
import { useSpin } from "../../components/SpinContext";
import { GetSingleShipment, UpdateShipment } from "../../api's/shipment";
import { appHelper, useToken } from "../../common/helper";
import { useNavigate } from "react-router-dom";
import { GetCompanySensors } from "../../api's/settings";
import ShipmentMultipleProductDetail from "./ShipmentMultipleProductDetail";

function EditShipmentDrawerWithTeams({ isOpen, toggleDrawer, shipmentId, onEditShipmentSuccess }) {
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
  const [form] = Form.useForm();
  const { token, removeToken } = useToken();
  const [shipment, setShipment] = useState({});
  const [sensorsList, setSensorsList] = useState([]);
  const { capitalize, formatDateToDayMonthYear, changeToTimeString } =
    appHelper();

  useEffect(() => {
    fetchSensors();
  }, []);

  const fetchSensors = () => {
    // showSpin();
    GetCompanySensors(token)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data.data?.is_success) {
            if (data.data.data && data.data.data.length > 0) {
              setSensorsList(data.data.data);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        // hideSpin();
      });
  };

  //get single shipment by shipment id
  useEffect(() => {
    if (shipmentId) {
      GetSingleShipmentById(shipmentId);
    }
  }, [shipmentId]);

  useEffect(() => {
    if (shipment) {
      //const selectedSensor = sensorsList.find(s => s.sensor_name === shipment.sensor?.type);
      form.setFieldsValue({
        // weight_kg: shipment?.weight_kg ? shipment.weight_kg.split(' ')[0] : '',
        weight_kg: shipment?.weight_kg,
        volume_m3: shipment?.volume_m3,
        link_code: shipment?.link_code || null,
        quantity: shipment?.product?.quantity,
        viability_window: shipment?.product?.viability_window,
        sensor_tracking_id: shipment?.sensor?.id,
        sensor: shipment.sensor?.sensor_id ? shipment.sensor?.sensor_id  : null,
        sensorType: shipment?.sensor?.type,
      });
    }
  }, [shipment, form]);

  const GetSingleShipmentById = (id) => {
    showSpin();
    GetSingleShipment(token, shipmentId)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              setShipment(resp);
            } else {
              message.error(data?.data?.message);
            }
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      let model = {
        ...values,
      };

      console.log(model);
      if (shipmentId) {
        model.shipment_id = shipmentId;
      }
      submitShipment(model);
    }
  };

  const submitShipment = (model) => {
    showSpin();
    UpdateShipment(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            toggleDrawer("close");
            onEditShipmentSuccess(data?.data?.data)
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const handleDrawerClose = () => {
    toggleDrawer("close");
  };

  return (
    <>
      <Form
        form={form}
        name="CreateNewShipment"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Flex vertical={true} gap={16}>
          <Flex gap={16} justify="space-between">
            <Flex vertical={true}>
              <CustomTitle
                text="Edit shipment"
                fontSize={15}
                color="#000"
                fontWeight={700}
                lineHeight={"28px"}
                marginBottom={"0px"}
              />
              <CustomTitle
                text={
                  "Changes to shipment details will only be made on ZoomLogi."
                }
                fontSize={12}
                fontWeight={400}
                lineHeight="20px"
                marginTop={"0px"}
                color="#5E5E5E"
                marginBottom="0"
              />
            </Flex>

            <Flex gap={8}>
              <CustomButton
                text={"Cancel"}
                width="57px"
                height="28px"
                fontSize="12px"
                fontWeight="600"
                lineHeight="16px"
                borderRadius="8px"
                bgColor="#F3F3F3"
                color="#000"
                boxShadow="none"
                onClick={handleDrawerClose}
              />

              <CustomButton
                text={"Save changes"}
                height="28px"
                fontSize="12px"
                fontWeight="600"
                lineHeight="16px"
                borderRadius="8px"
                bgColor="#000000"
                color="#ffffff"
                boxShadow="none"
                padding="0 12px"
                onClick={() => {
                  form.submit();
                }}
              />
            </Flex>
          </Flex>

          <Flex vertical={true} gap={16}>
            <Flex justify="space-between" align="center" gap={16}>
              <CustomTitle
                text={"Shipment details"}
                fontSize={15}
                fontWeight={700}
                lineHeight="28px"
                color="#000"
                marginBottom="0"
              />
            </Flex>

            <Row gap={24} justify="space-between">
              <Col span={11}>
                <CustomParagraph
                  text={"Origin"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.from_location?.address}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>

              <Col span={11}>
                <CustomParagraph
                  text={"Destination"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.to_location?.address}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
            </Row>

            <Row gap={24} justify="space-between">
              <Col span={11}>
                <CustomParagraph
                  text={"Scheduled pickup"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.scheduled_pickup_date}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>

              <Col span={11}>
                <CustomParagraph
                  text={"Schedule delivery"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.scheduled_delivery_date}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
            </Row>

            <Row gap={24} justify="space-between">
              <Col span={11}>
                <CustomParagraph
                  text={"Total weight (kg)"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <Form.Item
                  className="custom-input"
                  name="weight_kg"
                  rules={[
                    { required: true, message: "Please enter total weight" },
                  ]}
                  style={{ marginBottom: "0px" }}
                >
                  <CustomInput
                    placeholder="Enter weight"
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#000000"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item>
              </Col>

              <Col span={11}>
                <CustomParagraph
                  text={"Dimensions (volume)"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <Form.Item
                  className="custom-input"
                  name="volume_m3"
                  rules={[
                    { required: true, message: "Please enter dimensions" },
                  ]}
                  style={{ marginBottom: "0px" }}
                >
                  <CustomInput
                    placeholder="Enter dimensions"
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#000000"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gap={24} justify="space-between">
              

              <Col span={11}>
                <CustomParagraph
                  text={"Reference ID"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.reference_number}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
              <Col span={11}> 
              
              <CustomParagraph
                  text={"Link code (optional)"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                  style={{
                    borderBottom: "1px dotted #000",
                    display: "inline-block",
                  }}
                />
              <Form.Item
                  className="custom-input"
                  name="link_code"
                  rules={[
                    {
                      required: false,
                      pattern: /^[a-zA-Z0-9]{0,10}$/,
                      message: "Please enter up to 10 alphanumeric",
                    },]}              
                  style={{ marginBottom: "0px" }}>
                  <CustomInput
                    placeholder="Code"
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#000000"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* commercial value  */}
            <Row gap={24} justify="space-between">
              <Col span={11}>
                <CustomParagraph
                  text={"Total commercial value"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.total_commercial}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
{/* 
              <Col span={11}>
                <CustomParagraph
                  text={"Reference ID"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.reference_number}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col> */}
            </Row>

            <Flex justify="space-between" align="center" gap={16}>
              <CustomTitle
                text={"Products details"}
                fontSize={15}
                fontWeight={700}
                lineHeight="28px"
                color="#000"
                marginBottom="0"
              />
            </Flex>

            <Row gap={24} justify="space-between">
              {/* product name  */}
              <Col span={11}>
                <CustomParagraph
                  text={"Product"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.product?.name}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
              {/* quantity  */}
              <Col span={11}>
                <CustomParagraph
                  text={"Product quantity"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.product?.quantity}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
                {/* <Form.Item
                  className="custom-input"
                  name="quantity"
                  rules={[{ required: true, message: "Please enter quantity" }]}
                  style={{ marginBottom: "0px" }}
                >
                  <CustomInput
                    placeholder="Enter quantity"
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#000000"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item> */}
              </Col>
            </Row>

            <Row gap={24} justify="space-between">
              {/* product type  */}
              <Col span={11}>
                <CustomParagraph
                  text={"Product type"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.product?.product_type}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
              {/* project ID  */}
              <Col span={11}>
                <Tooltip title={shipment?.product?.project_id} placement="top">
                  <span>
                    <CustomParagraph
                      text={"Project ID"}
                      fontSize={12}
                      fontWeight={600}
                      lineHeight="16px"
                      color="#000"
                      marginBottom="4px"
                    />

                    <CustomParagraph
                      text={
                        shipment?.product?.project_id
                          ? (() => {
                            const projectIds =
                              shipment.product.project_id.split(",");
                            return projectIds.length > 2
                              ? `${projectIds.slice(0, 2).join(", ")}, +${projectIds.length - 2
                              }`
                              : projectIds.join(", ");
                          })()
                          : "--"
                      }
                      noText="--"
                      fontSize={12}
                      fontWeight={400}
                      lineHeight="16px"
                      color="#4B4B4B"
                      marginBottom="0"
                    />
                  </span>
                </Tooltip>
              </Col>
            </Row>
            <Row gap={24} justify="space-between">
              {/* Temperature range */}
              <Col span={11}>
                <Tooltip
                  title={
                    <div
                      style={{
                        textAlign: "center",
                        whiteSpace: "normal",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "120%",
                      }}
                    >
                      Temperature range overlap for all products
                    </div>
                  }
                  overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
                  placement="top"
                >
                  <CustomParagraph
                    text={"Temperature range"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />

                  <CustomParagraph
                    text={shipment?.product?.temperature_range}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </Tooltip>
              </Col>
              {/* Transit viability window */}
              <Col span={11}>
                <CustomParagraph
                  text={"Transit viability window"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"

                />

<CustomParagraph
                 text={
                  shipment?.product?.viability_window
                    ? shipment?.product?.viability_window + " hrs"
                    : "--"
                }
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />

                {/* <Form.Item
                  className="custom-input"
                  name="viability_window"
                  rules={[
                    {
                      required: true,
                      message: "Please enter viability window",
                    },
                  ]}
                  style={{ marginBottom: "0px" }}
                >
                  <CustomInput
                    placeholder="Enter viability window"
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#000000"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                    suffix="hrs"
                  />
                </Form.Item> */}
              </Col>
            </Row>

            {/* sensors  */}
            <Row gap={24} justify="space-between">
              <Col span={11}>
                <CustomParagraph
                  text={"Sensor"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <Form.Item
                  className="custom-input"
                  name="sensor"
                  style={{ marginBottom: "0px" }}
                >
                  <CustomDynamicSelect
                    placeholder="Select"
                    width="100%"
                    height="36px"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    options={sensorsList}
                    label="sensor_name"
                    isSensor={true}
                  />
                </Form.Item>
              </Col>

              <Col span={11}>
                <CustomParagraph
                  text={"Sensor ID"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <Form.Item
                  className="custom-input"
                  name="sensor_tracking_id"
                  dependencies={["sensorType"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      required: !!getFieldValue("sensorType"),
                      message: "Please enter sensor id",
                    }),
                  ]}
                  style={{ marginBottom: "0px" }}
                >
                  <CustomInput
                    placeholder="Enter sensor id"
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#000000"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Transport provider  */}
            <Flex justify="space-between" align="center" gap={16}>
              <CustomTitle
                text={"Transport provider"}
                fontSize={15}
                fontWeight={700}
                lineHeight="28px"
                color="#000"
                marginBottom="0"
              />
            </Flex>

            <Row gap={24} justify="space-between">
              <Col span={11}>
                <CustomParagraph
                  text={"Transport provider"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.courier?.title}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>

              <Col span={11}>
                <CustomParagraph
                  text={"Contact phone"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.contact_phone}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
            </Row>

            <Row gap={24} justify="space-between">
              <Col span={11}>
                <CustomParagraph
                  text={"Tracking ID"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.courier_tracking_id}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>

              <Col span={11}>
                <CustomParagraph
                  text={"Transport provider ETA"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={shipment?.transport_provider_eta}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Col>
            </Row>
          </Flex>
        </Flex>
      </Form>
    </>
  );
}

export default EditShipmentDrawerWithTeams;
